import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=1cff70ca"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cff70ca')) {
      api.createRecord('1cff70ca', component.options)
    } else {
      api.reload('1cff70ca', component.options)
    }
    module.hot.accept("./Collaborators.vue?vue&type=template&id=1cff70ca", function () {
      api.rerender('1cff70ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Collaborators.vue"
export default component.exports